import React, { useContext, useState } from 'react';
import { QueryModalContext } from '../querycontext';

export const QueryButton = ({ position = 'right' }) => {
    const { openModal } = useContext(QueryModalContext);
    const [isDragging, setIsDragging] = useState(false);
    const [positionStyle, setPositionStyle] = useState({
        top: '50%',
        [position]: '20px',
        transform: 'translateY(-50%)'
    });

    const handleMouseDown = (e) => {
        setIsDragging(true);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPositionStyle({
            top: `${e.clientY}px`,
            left: `${e.clientX}px`,
            right: 'auto',
            transform: 'none'
        });
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    return (
        <button
            onClick={openModal}
            onMouseDown={handleMouseDown}
            style={positionStyle}
            className={`fixed z-40 bg-[#00a3A1] hover:bg-[#0a8f8d] text-white rounded-full p-4 shadow-lg cursor-move transition-colors duration-300 ${isDragging ? 'shadow-xl scale-105' : ''}`}
            aria-label="Contact us"
        >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
        </button>
    );
};